var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1238 48L1238 76",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1238.5,
    cy: 43.3333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.99 43.1898C1233.99 39.2835 1237.29 36.1168 1241.36 36.1168C1241.94 36.1168 1242.51 36.1841 1243.06 36.3076C1241.74 35.4804 1240.19 35 1238.52 35C1233.81 35 1230 38.8056 1230 43.5C1230 48.1944 1233.81 52 1238.52 52C1240.81 52 1242.89 51.0929 1244.43 49.6205C1243.49 50.0317 1242.45 50.2628 1241.36 50.2628C1237.29 50.2628 1233.99 47.0961 1233.99 43.1898Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1247.4 42.6003L1247.37 40.1461L1245.54 41.7189L1243.3 41.0564L1244.11 43.3367L1242.77 45.3813L1245.1 45.2179L1246.5 47.144L1247.13 44.7627L1249.34 43.9085L1247.4 42.6003Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch7);
export default __webpack_public_path__ + "static/media/church_7.8986edf3066f3669332dcbb68ebcb57f.svg";
export { ForwardRef as ReactComponent };